import React from 'react';
import { ConversationModalState, ConvervationModalVariant } from '../../types';
import { AssignModal } from './assign-modal/assign-modal';
import { UpdateStatusModal } from './update-status-modal/update-status-modal';
import { ConversationData, FilterRoute } from '@zonofi/zono-money-store';
import { MoreActionsModal } from './more-actions-modal/more-actions-modal';
import { FilterModal } from '../../components';
import { TagsModal } from './tags-modal/tags-modal';
import { LifecycleModal } from './lifecycle-modal/lifecycle-modal';
import { TagsKey } from '../contstants';

interface ConversationsModalGroupProps {
  modalState: ConversationModalState;
  onCloseModal: () => void;
  updateConversations: (item: ConversationData) => void;
  refetchConversationList?: () => void;
  findTagType: (tag: string) => TagsKey;
  onActionPress: (payload: {
    action: ConvervationModalVariant;
    conversation: ConversationData;
  }) => void;
  filterState?: {
    open: boolean;
    page: string;
    close: () => void;
  };
}

export const ConversationsModalGroup: React.FC<
  ConversationsModalGroupProps
> = ({
  modalState,
  onCloseModal,
  updateConversations,
  refetchConversationList = () => {},
  onActionPress,
  filterState,
  findTagType,
}) => {
  const { conversation, open, variant } = modalState;
  const customerName = conversation.channelName ?? conversation.title ?? '';

  return (
    <React.Fragment>
      <AssignModal
        open={open && variant === 'assign'}
        onClose={onCloseModal}
        customerName={customerName}
        conversationId={conversation.conversationThreadId ?? ''}
        assignedTeamMembers={conversation.assignedTo ?? []}
        updateConversations={updateConversations}
      />
      <MoreActionsModal
        open={open && variant === 'more'}
        onClose={onCloseModal}
        customerName={customerName}
        onActionPress={(action) => onActionPress({ action, conversation })}
      />
      <UpdateStatusModal
        open={open && variant === 'update-status'}
        onClose={onCloseModal}
        customerName={customerName}
        conversationId={conversation.conversationThreadId ?? ''}
        currentStatus={conversation.status ?? ''}
        updateConversations={updateConversations}
      />
      <TagsModal
        open={open && variant === 'tags'}
        onClose={onCloseModal}
        conversation={conversation}
        findTagType={findTagType}
        updateConversations={updateConversations}
      />
      <LifecycleModal
        open={open && variant === 'lifecycle'}
        onClose={onCloseModal}
        conversation={conversation}
        updateConversations={updateConversations}
        refetchConversationList={refetchConversationList}
      />
      {filterState && (
        <FilterModal
          onClose={filterState.close}
          open={filterState.open}
          route={FilterRoute.Conversation}
          filterPage={filterState.page}
        />
      )}
    </React.Fragment>
  );
};
